import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer1 from "../navbar/Footer1";
import "./Works.css";

const Works = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingProjects, setLoadingProjects] = useState(true);

  const API_BASE_URL = "https://vogelkoparchitects.com/api/api";

  // Fetch categories
  useEffect(() => {
    fetch(`${API_BASE_URL}/categories/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCategories(data);
        setLoadingCategories(false);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
        setLoadingCategories(false);
      });
  }, []);

  // Fetch all projects initially
  useEffect(() => {
    const fetchAllProjects = async () => {
      setLoadingProjects(true);
      try {
        const response = await fetch(`${API_BASE_URL}/projects/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setProjects(data);
        setLoadingProjects(false);
      } catch (error) {
        console.error("Error fetching projects:", error);
        setLoadingProjects(false);
      }
    };

    fetchAllProjects();
  }, []);

  // Handle project click - navigate to project detail page
  const handleProjectClick = (projectId) => {
    navigate(`/project-detail/${projectId}`);
  };

  // Filter projects based on selected category
  const getFilteredProjects = () => {
    if (selectedCategoryId) {
      return projects.filter(project => 
        project.category && project.category.id === selectedCategoryId
      );
    }
    return projects;
  };

  const filteredProjects = getFilteredProjects();

  return (
    <div className="works-page">
      {/* Hero Banner with "Projects" text in bottom-left corner */}
      <div className="works-hero">
        <div className="works-hero-bg">
          <div className="works-hero-overlay"></div>
        </div>
        <div className="works-hero-content">
          <h1 className="works-hero-title">WORKS</h1>
        </div>
      </div>

      <div className="works-container">
        {/* Category Filters - No colors at all, only black and white */}
        <div className="works-filters">
          {loadingCategories ? (
            <div className="filter-loading">Loading categories...</div>
          ) : (
            <div className="filter-buttons">
              <button
                className={`filter-btn ${selectedCategoryId === null ? "active" : ""}`}
                onClick={() => setSelectedCategoryId(null)}
              >
                All Works
              </button>
              {categories.map((category) => (
                <button
                  key={category.id}
                  className={`filter-btn ${selectedCategoryId === category.id ? "active" : ""}`}
                  onClick={() => setSelectedCategoryId(category.id)}
                >
                  {category.title}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Projects Grid - 3 cards per row */}
        <div className="works-grid">
          {loadingProjects ? (
            <div className="works-loader">
              <div className="loader"></div>
              <p>Loading projects...</p>
            </div>
          ) : filteredProjects.length > 0 ? (
            filteredProjects.map((project) => (
              <div 
                key={project.id} 
                className="work-card"
                onClick={() => handleProjectClick(project.id)}
              >
                <div className="work-card-image">
                  <img
                    src={project.image || "/placeholder.jpg"}
                    alt={project.title}
                    onError={(e) => {
                      e.target.src = "/placeholder.jpg";
                    }}
                  />
                  {/* Title in bottom-left corner of card */}
                  <div className="card-title-overlay">
                    <h3 className="card-title">{project.title}</h3>
                  </div>
                  {/* Hover Overlay - Shows full description with arrow in bottom-right */}
                  <div className="work-card-overlay">
                    <div className="overlay-content">
                      <p className="overlay-description">
                        {project.description ? project.description : "No description available"}
                      </p>
                      {/* Diagonal Arrow - Bottom Right Corner */}
                      <div className="round-arrow">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="7" y1="17" x2="17" y2="7"></line>
                          <polyline points="7 7 17 7 17 17"></polyline>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-projects">
              <p>No works found in this category.</p>
              <button 
                className="reset-btn"
                onClick={() => setSelectedCategoryId(null)}
              >
                View All Works
              </button>
            </div>
          )}
        </div>
      </div>

      <Footer1 />
    </div>
  );
};

export default Works;